<ng-container *ngIf="summaryData">
  <th *ngIf="showRowHeader" class="table-summary-row-header">{{rowTitle}}</th>
  <ng-container *ngFor="let cell of summaryData.cells">
    <th *ngIf="!_hideCell(cell.column, columns)">
      {{ _formatCellValue(cell.value, cell.displayPipeArgs, cell.prefix, cell.postfix) }}
    </th>
  </ng-container>
  <th *ngIf="showRowActions"></th>
</ng-container>
